import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { PacientesRoutingModule } from './pacientes-routing.module';
import { PacientesComponent } from './pages/pacientes/pacientes.component';
import { ListPacientesComponent } from './components/list-pacientes/list-pacientes.component';
import { ProntuarioComponent } from './pages/prontuario/prontuario.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    MatIconModule,
    PacientesRoutingModule
  ],
  declarations: [
    PacientesComponent,
    ListPacientesComponent,
    ProntuarioComponent
  ]
})
export class PacientesModule {}
